import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';

const MOCK_EARNINGS = [
  { id: 1, employeeId: 'EMP001', month: 'Jan', leaveType: 'Annual', earned: 1.17, generatedDate: '31 Jan' },
  { id: 2, employeeId: 'EMP002', month: 'Feb', leaveType: 'Annual', earned: 1.17, generatedDate: '28 Feb' },
  { id: 3, employeeId: 'EMP001', month: 'Feb', leaveType: 'Annual', earned: 1.17, generatedDate: '28 Feb' },
  { id: 4, employeeId: 'EMP003', month: 'Feb', leaveType: 'Casual', earned: 0.58, generatedDate: '28 Feb' },
];

export default function LeaveEarnings() {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return MOCK_EARNINGS;
    return MOCK_EARNINGS.filter(
      (e) => e.employeeId.toLowerCase().includes(q) || e.leaveType.toLowerCase().includes(q)
    );
  }, [search]);

  return (
    <div className="min-h-full bg-surface-50">

      {/* ── Table card ──────────────────────────────────────────── */}
      <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-100 p-5">
          <div className="relative max-w-xs">
            <Search size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by employee or leave type"
              className="w-full rounded-lg border border-gray-200 bg-surface-50 py-2.5 pl-10 pr-3 text-sm text-gray-800 placeholder-gray-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px] border-collapse text-sm">
            <thead>
              <tr className="bg-black">
                {['Employee', 'Month', 'Leave Type', 'Earned', 'Generated Date'].map((h) => (
                  <th
                    key={h}
                    className="whitespace-nowrap px-5 py-3 text-left text-xs font-semibold uppercase tracking-wide text-primary-400"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-5 py-10 text-center text-sm text-gray-400">
                    No earnings records match your search.
                  </td>
                </tr>
              )}
              {filtered.map((e, i) => (
                <tr key={e.id} className={i % 2 === 1 ? 'bg-surface-50/40' : ''}>
                  <td className="px-5 py-4 font-medium text-gray-900">{e.employeeId}</td>
                  <td className="px-5 py-4 text-gray-700">{e.month}</td>
                  <td className="px-5 py-4 text-gray-700">{e.leaveType}</td>
                  <td className="px-5 py-4 font-semibold text-primary-700">{e.earned}</td>
                  <td className="px-5 py-4 text-gray-500">{e.generatedDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}